module.exports = __webpack_public_path__ + "img/function-004.e31396e4.png";